module.exports = __webpack_public_path__ + "img/2.840f591.png";